interface PortalLinkProps {
  trackingNumber: string;
  isMobile?: boolean;
}

export const PortalLink = ({ trackingNumber, isMobile }: PortalLinkProps) => {
  if (isMobile) {
    return (
      <span className='tracking-pill relative flex h-12 w-fit items-center rounded-full pl-10 pr-4'>
        <span className='tracking-pill-icon absolute -left-4 flex h-12 w-12 shrink-0 items-center justify-center rounded-full'>
          <svg
            width='20'
            height='20'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'
              stroke='#0c3a44'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M12 10h.01M12 7h.01'
              stroke='#0c3a44'
              strokeWidth='2.5'
              strokeLinecap='round'
            />
          </svg>
        </span>
        <span className='text-sm font-bold tracking-wide text-white'>
          {trackingNumber}
        </span>
      </span>
    );
  }

  return (
    <span className='tracking-pill relative flex h-[58px] w-fit shrink-0 items-center rounded-full pl-12 pr-4 text-[22px] font-bold tracking-wide text-white'>
      <span className='tracking-pill-icon absolute -left-5 flex h-[58px] w-[58px] shrink-0 items-center justify-center rounded-full'>
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'
            stroke='#0c3a44'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M12 10h.01M12 7h.01'
            stroke='#0c3a44'
            strokeWidth='2.5'
            strokeLinecap='round'
          />
        </svg>
      </span>
      {trackingNumber}
    </span>
  );
};
